import { useMemo } from 'react';
import { useGlobalState } from '../presentation/global/context/global-context';
import { IMenuResponse } from '../model/base/response/menu-response';

export const useMenusData = () => {
    const { menus } = useGlobalState();

    const filteredMenus = useMemo(() => {
        if (!menus) return [];

        return menus
            .map((menu: IMenuResponse) => ({
                ...menu,
                items: menu.items?.filter(item => item.isPublished === true).sort((a, b) => (a.orderNumber || 0) - (b.orderNumber || 0)) || []
            }))
            .filter((menu: IMenuResponse) => menu.items && menu.items.length > 0)
            .sort((a: IMenuResponse, b: IMenuResponse) => (a.orderNumber || 0) - (b.orderNumber || 0));
    }, [menus]);

    return { menus: filteredMenus, loading: !menus };
};
